import React, { useEffect, useState } from 'react';
import { Package, Grid3x3, ShoppingBag, TrendingUp } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { getProducts, getCategories, getReservations } from '../../utils/firestoreService';

export const AdminDashboard = () => {
  const { user } = useAuth();
  const [stats, setStats] = useState({
    products: 0,
    categories: 0,
    reservations: 0,
    totalRevenue: 0,
  });

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const [productsData, categoriesData, reservationsData] = await Promise.all([
        getProducts(),
        getCategories(),
        getReservations(),
      ]);

      const totalRevenue = reservationsData.reduce(
        (sum, r) => sum + (r.totalAmount || 0),
        0
      );

      setStats({
        products: productsData.length,
        categories: categoriesData.length,
        reservations: reservationsData.length,
        totalRevenue,
      });
    } catch (error) {
      console.error('Error fetching stats:', error);
      setStats({
        products: 0,
        categories: 0,
        reservations: 0,
        totalRevenue: 0,
      });
    }
  };

  const statCards = [
    {
      title: 'Productos',
      value: stats.products,
      icon: Package,
      color: 'bg-[#00C2CB]',
      testId: 'stat-products',
    },
    {
      title: 'Categorías',
      value: stats.categories,
      icon: Grid3x3,
      color: 'bg-[#FFD700]',
      testId: 'stat-categories',
    },
    {
      title: 'Compras',
      value: stats.reservations,
      icon: ShoppingBag,
      color: 'bg-[#FF6B00]',
      testId: 'stat-reservations',
    },
    {
      title: 'Total Comprado',
      value: `$${stats.totalRevenue.toLocaleString()}`,
      icon: TrendingUp,
      color: 'bg-green-500',
      testId: 'stat-revenue',
    },
  ];

  return (
    <div className="p-8">
      <h1 className="text-4xl font-fredoka font-bold text-[#1A1A2E] mb-8" data-testid="dashboard-title">
        Dashboard
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {statCards.map((stat) => {
          const Icon = stat.icon;
          return (
            <div
              key={stat.title}
              className="bg-white rounded-2xl p-6 shadow-lg"
              data-testid={stat.testId}
            >
              <div className="flex items-center justify-between mb-4">
                <div className={`w-12 h-12 ${stat.color} rounded-xl flex items-center justify-center`}>
                  <Icon className="w-6 h-6 text-white" />
                </div>
              </div>
              <p className="text-[#4A4A6A] font-quicksand font-semibold mb-1">{stat.title}</p>
              <p className="text-3xl font-fredoka font-bold text-[#1A1A2E]">{stat.value}</p>
            </div>
          );
        })}
      </div>

      <div className="mt-12 bg-white rounded-2xl p-8 shadow-lg">
        <h2 className="text-2xl font-fredoka font-bold text-[#1A1A2E] mb-4">
          Bienvenido al Panel de Administración
        </h2>
        <p className="text-[#4A4A6A] font-quicksand text-lg">
          Gestiona tus productos, categorías y revisa las compras de tus clientes desde este panel.
        </p>
      </div>
    </div>
  );
};